module.exports = __webpack_public_path__ + "img/XRP.a17ffdeb.svg";